<template>
   <section id="manage-workspace" class="card my-2 p-2">
   <div>
     		<div v-if="resultbuyingdomain != 'DONE'">
       				
       				<div class="card p-2 mt-3">
       				<div class="">
       					<button @click="getDomainsFree()" :disabled="domaincom.length == 0 || buying" class="btn btn-sm btn-primary">See available domains</button>
       				</div>
       				<li v-for="d in domainsfree" class="my-2">{{d.domain}} | {{d.created}} | {{d.workspace_id}} <i v-if="d.dns[0]" class="icon-checkmark text-success mx-2"></i> <button :disabled="buying" class="btn btn-sm btn-primary" @click="reUseDoman(d.domain)">Re-use this domain</button></li>
       				</div>

     		<input @input="recalculate()"  v-model="domainname" class="mr-1 my-1"></input> 
       				<button @click="buyNow()" :disabled="domaincom.length == 0 || buying" class="btn btn-sm btn-primary mx-2">Buy {{domaincom}}(-pro).com </button>
       	</div>
       	</div>
       		 		<span v-if="buying"> 
	       		 		<span class="loadingres spinner-border loading-spinner ml-2"></span> buying...{{buyingdomain}} 
       		 		</span>
	       		 	<span class="badge badge-danger" v-if="resultbuyingdomain == 'Unavailable'">{{resultbuyingdomain}}</span>
	       		 	<span class="badge badge-success" v-if="resultbuyingdomain == 'DONE'">{{resultbuyingdomain}} {{buyingdomain}}</span> 	
	       		 	<span  v-if="resultbuyingdomain == 'DONE'">Please, go to <strong>admin.google.com</strong> in the workspace <strong>{{project.email_owner}}</strong> and validate the domain <strong>{{buyingdomain}}</strong> manually.</span>
 		 		<div v-if="resultbuyingdomain != 'DONE'">
 		 			Options: <div class="row">
            <small class="col-12" 
              v-for="(pref, i) in prefix.split(',')" :key="i">
              {{pref}}{{domaincom}}.com
            </small>
        </div>
 		 		</div>
   </section>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { workspaceService } from "@/_services";

export default {
  props: {
    domain: "",
    prefix: "",
    project: false,
  },
  data() {
    return {
      loading: false,
      domainsfree: [],
      buying: false,
      domaincom: false,
      domaintobuy: [],
      domainname: "",
      buyingdomain: "",
      resultbuyingdomain: "",
    };
  },

  created() {
    this.loading = true;
    this.domainname = this.domain.name;
    this.recalculate();
  },
  methods: {
    recalculate() {
      let domainne;
      domainne = this.getDomainProcessed(this.domainname);
      this.domaincom = domainne;
    },

    getDomainsFree() {
      workspaceService
        .getFreeDomainsByClient(this.domain.client_id)
        .then((result) => {
          this.domainsfree = result;
        });
    },

    reUseDoman(domainuse) {
      this.buying = true;
      workspaceService
        .reUseDomain(domainuse, this.domain, this.project)
        .then((result) => {
          this.resultbuyingdomain = "DONE";
          this.buying = false;
        });
    },

    buyNow() {
      this.buying = true;
      this.executeSequentially(0);
    },

    executeSequentially(index) {
      let prefixword = this.prefix.split(",");

      if (index >= prefixword.length) {
        // No se encontró el resultado deseado
        this.buying = false;
        return;
      }

      const item = prefixword[index];

      this.buyingdomain = item + this.domaincom + ".com";
      this.resultbuyingdomain = "";
      workspaceService
        .buyNow(this.buyingdomain, this.domain, this.project)
        .then(
          (result) => {
            if (result == "ok") {
              // Se encontró el resultado deseado
              this.resultbuyingdomain = "DONE";
              this.buying = false;
              return;
            } else {
              this.resultbuyingdomain = "Unavailable";

              // Sigue con la ejecución secuencial
              this.executeSequentially(index + 1);
            }
          },
          (error) => {
            this.$swal({
              type: "error",
              title: this.$t("lang.label.error"),
              text: error,
              showConfirmButton: true,
            });
          }
        );
    },

    getDomainProcessed(domain) {
      domain = domain.replace(/\s/g, "");
      let reemplazos = {
        à: "a",
        á: "a",
        â: "a",
        ç: "c",
        é: "e",
        è: "e",
        ê: "e",
        ë: "e",
        î: "i",
        ï: "i",
        ô: "o",
        ù: "u",
        û: "u",
        ü: "u",
      };
      Object.entries(reemplazos).forEach(([caracter, reemplazo]) => {
        const regex = new RegExp(caracter, "g");
        domain = domain.replace(regex, reemplazo);
      });

      domain = domain.toLowerCase();

      return domain;
    },
  },
};
</script>